<template lang="pug">
  .component-backoffice-driver-license-attachment-upload(v-if="item")
    dropzone#myVueDropzone(ref="dropzone", :url='dropzoneUrl', @vdropzone-success='uploaded', @vdropzone-removed-file="removeAttachment")
    button.button.expanded(v-on:click="upload", v-bind:class="{disabled:attachments.length === 0}") Save and Submit

</template>

<script type="text/babel">
  import Dropzone from 'components/structure/Dropzone'
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import MaggieHelper from "src/maggieHelper";

  export default {
    name: "BackofficeDriverLicenseAttachmentUpload",
    components: {
      Dropzone
    },
    data() {
      return {
        attachments: [],
        dropzoneUrl: KeplerBackofficeSdk.getUrlForDropzone()+''
      }
    },
    methods: {
      removeAttachment(file) {
        var tokenOnQueue = JSON.parse(file.xhr.response).token
        this.attachments.forEach((token, key) => {
          if (token === tokenOnQueue) {
            this.attachments.splice(key, 1)
          }
        })
      },
      uploaded: function (file, response) {
        this.attachments.push(response.token)
      },
      upload() {
        this.attachments.forEach((token, key) => {
          KeplerBackofficeSdk.driverLicenses.select(this.item.id).addAttachment({attachment_token: token}, (data) => {
            this.attachments.splice(key, 1)
            MaggieHelper.notification('upload-esit', 'Attachment uploaded')
            this.$emit('attachmentUploaded')
            this.$refs.dropzone.removeAllFiles()
            MaggieHelper.closeRightPanel()
            window.location.reload()
          })
        })
      }
    },
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverLicenseAttachmentUpload.vue?10724cd3